import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import DoubleForwaedHelixPiercingImage from '../../Assets/Piercing Services/double forward helix piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function DoubleForwaedHelixPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Double Forward Helix Piercing UAE | 250 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Double Forward Helix Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Double Forward Helix Piercing 250 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={DoubleForwaedHelixPiercingImage} alt="Double Forward Helix Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Double Forward Helix Piercing</h3>

          <p>
            Enhance your ear styling with our professional double forward helix piercing services in the UAE, available at an affordable price of 250 AED. Double forward helix piercing is a modern and eye-catching cartilage piercing that features two piercings placed on the front outer rim of the ear, just above the tragus. This double-layered design creates a unique and stylish look, perfect for individuals who want to add depth and personality to their ear aesthetics. Whether you prefer matching studs for a clean and minimal vibe or a combination of jewelry for a bold statement, our expert specialists ensure precise placement for a balanced and visually appealing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each double forward helix piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. With advanced techniques designed to reduce discomfort, we ensure that the procedure is quick, efficient, and as pain-minimized as possible, even with two piercings.
          </p>

          <p>
            Double forward helix piercing is ideal for those who want to stand out with a refined yet distinctive style. It pairs beautifully with other ear piercings such as lobe, helix, tragus, or conch, allowing you to create a fully curated and layered ear design. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry combinations to achieve your desired look. This personalized approach ensures that your piercing complements your ear structure and overall style perfectly.
          </p>

          <p>
            The procedure is typically completed within a short time, making it convenient even for clients with busy schedules. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process. Our goal is to deliver not just a stylish result, but also a comfortable and safe experience from start to finish.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cartilage piercings can feel intimidating, especially when getting multiple piercings, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a positive and stress-free experience.
          </p>

          <p>
            Aftercare is an essential part of maintaining your double forward helix piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your piercing will heal effectively and remain a long-lasting addition to your style.
          </p>

          <p>
            Our double forward helix piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted double forward helix piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a commitment to customer satisfaction, we help you achieve a unique and stylish look effortlessly. Book your double forward helix piercing appointment today and elevate your ear styling with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Double Forward Helix Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default DoubleForwaedHelixPiercing;